module.exports = __webpack_public_path__ + "static/img/1-2.0fca2f8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/1-2.png
// module id = H3hM
// module chunks = 0